import React, {useEffect, useState} from 'react';
import {useIdleTimer} from 'react-idle-timer'

import {View} from "./components/View";
import {retrieveTemporaryObject, saveTemporaryObject} from "./services/TemporaryStorageService";
import {Spinner} from "./components/common/spinner/Spinner";
import {createStaffMember, retrieveLoggedInSystemUser} from "./services/StaffMemberService";
import {sendAutomaticRegistrationRequest} from "./services/EmailService";

export const App = ({keycloak}) => {
    const username = keycloak.idTokenParsed.preferred_username;
    const roles = keycloak.realmAccess.roles;
    const [context, setContext] = useState();
    const [spinnerText, setSpinnerText] = useState(null);

    const createNewSystemUser = async () => {
        const systemUserToCreate = {
            firstName: keycloak.idTokenParsed.given_name,
            lastName: keycloak.idTokenParsed.family_name,
            userName: keycloak.idTokenParsed.preferred_username,
            email: keycloak.idTokenParsed.email,
            organisation: keycloak.idTokenParsed.organisation,
            organisationRole: keycloak.idTokenParsed.organisationRole,
            active: true,
        };

        const [data, error] = await createStaffMember("admin", systemUserToCreate);
        if (data) {
            if (data.responseStatus === "Success") {
                await initialiseContext();
                await sendAutomaticRegistrationRequest(systemUserToCreate.userName, systemUserToCreate.email);
            } else {
                console.error(data.responseMessage);
            }
        } else {
            console.error(error)
        }
    }

    const initialiseContext = async () => {
        setSpinnerText("Retrieving Logged In User");
        const [data, error] = await retrieveLoggedInSystemUser(username);
        if (data) {
            if (data.responseStatus === "Success") {
                setContext({
                    currentScreen: "dashboardProfile",
                    viewStack: [],
                    breadcrumbs: [],
                    activeSection: "Profile",
                    username,
                    roles,
                    loggedInUser: data.systemUserVO,
                });
            } else {
                await createNewSystemUser();
            }
        } else {
            console.error(error);
        }
    }

    useEffect(() => {
        setSpinnerText("Retrieving session");
        const fetchData = async () => {
            const [data] = await retrieveTemporaryObject(username, username);
            if (data) {
                if (data.responseStatus === "Success") {
                    const retrievedContext = JSON.parse(data.temporaryStorageVOToView.value);
                    const roles = keycloak.realmAccess.roles;
                    setContext({...retrievedContext, roles});
                } else {
                    await initialiseContext();
                }
            } else {
                await initialiseContext();
            }
            setSpinnerText(null);
        }
        fetchData();
    }, []);

    useEffect(() => {
        const saveData = async () => {
            await saveTemporaryObject(username, {key: username, value: JSON.stringify(context)});
        }
        saveData();
    }, [context]);

    useIdleTimer({
        timeout: 1000 * 60 * 5, // 5 minutes
        onIdle: keycloak.logout,
    });

    return (
        <div>
            {context && <View keycloak={keycloak} context={context} setContext={setContext} spinnerText={spinnerText}
                              setSpinnerText={setSpinnerText} toolTipsEnabled={context.loggedInUser.toolTipsEnabled}/>}
            {spinnerText && <Spinner loadingText={spinnerText}/>}
        </div>
    );
}
